module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/dog.svg?a1f0d66d9bdad7381bd271dd1c2ddf74";